<template>
  <div>
    <div v-if="dataRow.length != 0">
      <div v-for="(item, index) in dataRow" :key="index">
        <span>{{ index + 1 }}. </span>
        <el-rate style="display: inline-block" v-model="item.starsNum" disabled show-score text-color="#ff9900"
          score-template="{value}">
        </el-rate>
        <div style="text-indent: 20px">
          {{ item.content }}
        </div>
      </div>
    </div>
    <div v-else>
      <n-empty description="暂无记录"> </n-empty>
    </div>
    <div>
      <el-row type="flex" class="row-bg">
        <el-col :span="10">
          <div class="mt-10">
            <n-form-item label="提交您的课程评价：" :label-style="{ fontSize: '18px' }">
              <n-input v-model:value="content" placeholder="请输入您的课程评价" type="textarea" show-count :rows="10"
                maxlength="10" />
            </n-form-item>
            <div>
              <el-rate v-model="value1"></el-rate>
            </div>
            <div class="flex justify-center">
              <el-button class="px-10" :loading="loading" type="primary" @click="submit">提 交</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="10">

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { saveCourseEvaluate, pageCourseEvaluate } from '@/api/index';
export default {
  props: {
    // 课程id
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data () {
    return {
      value: 2,
      dataRow: [],
      value1: '5',
      content: '',
    };
  },
  methods: {
    submit () {
      console.log('提交了');
      console.log(this.data.id);
      console.log(this.content);

      if (this.content === '') {
        return this.$message({
          type: 'info',
          message: '请填写评论',
        });
      } else {
        let data = {
          content: this.content,
          targetId: this.data.id,
          starsNum: this.value1,
        };
        saveCourseEvaluate(data).then(res => {
          if (res.success === true) {
            this.$message({
              type: 'success',
              message: '提交成功',
            });
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
            });
          }
        });
      }
    },
    initial () {
      pageCourseEvaluate({ targetId: this.data.id }).then(res => {
        const data = res.data.records;
        this.dataRow = data;
      });
    },
  },
  mounted () {
    this.initial();
  },
};
</script>
